import { Middleware } from "../Middleware";
import { MiddlewareInterface } from "../MiddlewareInterface";
import Translator from "../../Translation/Translator";
import Decoder from "../../Token/Decoder";
import Token from "../../Token/Token";
import Constants from "../../Action/Constants";

class ConfirmWillMount extends Middleware implements MiddlewareInterface {

  public component: any;

  constructor() {
    super();
  }

  public process(): void {
    const storageToken = Token.getInstant() && Decoder.decode(Token.getInstant());

    // If we are already logged in, ignore this page.
    if (!!storageToken && !storageToken.isExpired && this.component.props.app.loadedEntities.length > 0) {
      return this.component.redirect("/app/dashboard/overview");
    }
    // If we have token on the URL, then it means we clicked on the confirmation email.
    if (!!this.component.props?.location?.query?.token) {
      const token = Decoder.decode(this.component.props?.location?.query?.token);
      this.component.props.dispatch({
        type: Constants.IS_TOKEN_USED_CHECK_START,
        payload: {
          token: this.component.props?.location?.query?.token,
        },
        onSuccess: () => {
          this.component.setState({
            tokenAlreadyUsed: false
          })
        },
        onError: () => {
          this.component.setState({
            tokenAlreadyUsed: true
          })
        },
      })

      if (this.component.props?.location?.query?.lang) {
        // Set the language depending location query parametr (sent from  the back-end)
        Translator.use(this.component.props?.location?.query?.lang);
      } else {
        // Set default language Dutch
        Translator.use("nl-NL");
      }

      if (token.isExpired) {
        this.component.state.id = token.id;
        this.component.state.email = token.email;
        this.component.state.type = this.component.types.expired;
        return;
      }

      // If type is different, throw an error.
      if (typeof this.component.types[token.type] === "undefined") {
        throw new Error(`Invalid token type.`);
      }

      this.component.state.type = this.component.types[token.type];
    }
  }
}

export default new ConfirmWillMount();
